import $ from 'jquery';
import Util from './utils';

const IS_LOCALHOST = location.host.indexOf("localhost") >= 0;
const ATTEMPTED_FAVORITE_TYPE_PARAM = "favType";
const ATTEMPTED_FAVORITE_GUID_PARAM = "favNodeGUID";

const FAVORITE_MODAL_ID = "favorite-modal";
const UNFAVORITE_MODAL_ID = "unfavorite-modal";
const SIGNIN_MODAL_ID = "signin-modal";
// Retrieve value of window.msh.siteUrl. It is being set in the html head of the page layout.
// The environment specific msh:siteurl app setting is being used.
// For cases where this js is being used on the MSH site, then window.msh.siteUrl will be empty string since
// the URL paths are relative.
const MSH_SITE_URL = (((typeof window.msh === 'undefined') || (typeof window.msh.siteUrl === 'undefined')) ? '' : window.msh.siteUrl.endsWith('/') ? window.msh.siteUrl.slice(0, -1) : window.msh.siteUrl);

//Flag used to ensure attempted favorites coming back from a MSH login
//is processed only once on this page instance.
var processedAttemptedFav = false;

/**
 * Initializes the like functionality on cards through out the site
 *
 * buttons {jQuery object} - jquery object pointing to like buttons to init. if null, all like buttons on the page will be selected.
 */
function initFavoriteButtons(buttons) {
    var CLICK_FAVORITE_BUTTON_EVENT = "click.favoriteButton";

    var urlParams = Util.getUrlParameters();
    var attemptedFavoriteType = urlParams[ATTEMPTED_FAVORITE_TYPE_PARAM];
    var attemptedFavoriteGUID = urlParams[ATTEMPTED_FAVORITE_GUID_PARAM];

    var processPostResponse = function processPostResponse(data) {
        if (data.status === "success" || data.IsSuccess === true) {
            // Look for each button with this node guid
            var buttons = getFavoriteButtonsByNodeGuid(attemptedFavoriteGUID);
            buttons.each(function (index, button) {
                updateFavoriteButtonState(button, true, attemptedFavoriteGUID, data.numfavcomms, true);
            });
        }
    }

    if (processedAttemptedFav == false && attemptedFavoriteType != null && attemptedFavoriteType.length > 1
        && attemptedFavoriteGUID != null && attemptedFavoriteGUID.length > 1) {

        var buttons = getFavoriteButtonsByNodeGuid(attemptedFavoriteGUID);

        if (buttons.length > 0) { //make sure the UI is rendering the button before processing it.

            //Found the corresponding elements where favoriting was attempted.
            //Set the flag that those items are processed 
            processedAttemptedFav = true;

            if ('event' == attemptedFavoriteType) {
                //Post body
                let postBody = {
                    FavoriteType: attemptedFavoriteType,
                    NodeGuid: attemptedFavoriteGUID,
                    Action: 'add'
                };
                //Call favorite events API
                $.post({
                    url: MSH_SITE_URL + '/mshapi/favorites/postfavoriteevents',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(postBody),
                    xhrFields: {
                        withCredentials: true
                    },
                }).done(
                    processPostResponse
                ).fail(function () {
                }).always(function () {
                });
            }
            else {
                //Post body
                let postBody = {
                    type: attemptedFavoriteType,
                    addRemove: 'add',
                    nodeGuid: attemptedFavoriteGUID
                };
                // Send the AJAX request
                $.post({
                    url: MSH_SITE_URL + '/mshapi/favorites/postfavorites',
                    dataType: 'json',
                    contentType: 'application/json',
                    data: JSON.stringify(postBody),
                    xhrFields: {
                        withCredentials: true
                    },
                }).done(
                    processPostResponse
                ).fail(function () {
                }).always(function () {
                });
            }
        }
    }

    $.post({
        url: MSH_SITE_URL + '/mshapi/favorites/canfavorite',
        dataType: 'json',
        xhrFields: {
            withCredentials: true
        },
    }).done(function (data) {
        var isUserAuthorized = false;
        if (data.message == "yes") {
            isUserAuthorized = true;
        }

        // Grab references to all buttons or to specific buttons if the buttons parameter is not null
        var favButtons = getAllFavoriteButtons();
        if (buttons != null) {
            favButtons = buttons;
        }

        $(favButtons).each(function (index, button) {
            //Attach a click handler to the favorite button to set focus to this button
            //when it's modal popup is closed.
            $(button).click(function (sender, args) {

                var focusCloseHandler = function () {
                    //Set focus on the favorite button 
                    $(button).focus();

                    //Immediately remove this focus handler when it's modal is closed to
                    //allow other buttons that are clicked to gain focus when their modal popup is closed.
                    $('.message-modal, .unfavorite-modal').unbind("closed.zf.reveal", focusCloseHandler);
                };

                //Attach the focus handler to this button when it's modal popup is closed.
                $('.message-modal, .unfavorite-modal').bind("closed.zf.reveal", focusCloseHandler);
            });

            var isLiked = $(this).hasClass("liked");

            // Handle click events and update attributes as needed
            $(button).off(CLICK_FAVORITE_BUTTON_EVENT).on(CLICK_FAVORITE_BUTTON_EVENT, function (e) {
                e.preventDefault();

                var btn = $(this);

                var isLiked = btn.hasClass("liked");
                var type = btn.data("type");
                var nodeGUID = $(this).data("node-guid");
                var numfavcomms = 0;

                if (IS_LOCALHOST === false) {
                    if (isUserAuthorized == false) {
                        // Set the return url from signin to the current page w/ URL params
                        // in the signin link
                        $('#' + SIGNIN_MODAL_ID + ' a.signin-link').each(function () {
                            let anchor = $(this);
                            //Append the favorited item type, and nodeguid as return params
                            //to the signin link so that we can add it as a favorite after the user logs in
                            let retUrl = document.location.href;
                            if (retUrl.indexOf('?') != -1) {
                                retUrl = retUrl + '&';
                            } else {
                                retUrl = retUrl + '?';
                            }
                            let favoritingParameters = ATTEMPTED_FAVORITE_TYPE_PARAM + '=' + type + '&' + ATTEMPTED_FAVORITE_GUID_PARAM + '=' + nodeGUID;
                            retUrl = retUrl + favoritingParameters;

                            anchor.attr('href', anchor.attr('href') + '?returnurl=' + encodeURIComponent(retUrl));
                        });
                        // Open the unfavorite modal (no need to set attributes since this should have been handled in BE)
                        $('#' + SIGNIN_MODAL_ID).foundation('open');
                    }
                    else if (isLiked === true) {
                        // Before removing favorite, confirm that they wish to in fact remove the favorite
                        // Open the unfavorite modal
                        $("#" + UNFAVORITE_MODAL_ID).foundation('open');

                        // Attach click handler to confirmation and cancel buttons on the unfavorite modal
                        $("#unfavorite-modal .confirmation-button").one("click", function () {

                            if (type == 'event') {
                                //Post body
                                let postBody = {
                                    FavoriteType: type,
                                    NodeGuid: nodeGUID,
                                    Action: 'remove'
                                };
                                //Call favorite events API
                                $.post({
                                    url: MSH_SITE_URL + '/mshapi/favorites/postfavoriteevents',
                                    dataType: 'json',
                                    contentType: 'application/json',
                                    data: JSON.stringify(postBody),
                                    xhrFields: {
                                        withCredentials: true
                                    },
                                }).done(function (data) {
                                    if (data.IsSuccess) {
                                        btn = getFavoriteButtonsByNodeGuid(nodeGUID);
                                        updateFavoriteButtonState(btn, false, nodeGUID, 0, true);
                                    }
                                }).fail(function () {
                                }).always(function () {
                                });
                            } else {
                                // Make MVC request to attempt to unfavorite the community
                                //Post body
                                let postBody = {
                                    type: type,
                                    addRemove: 'remove',
                                    nodeGuid: nodeGUID
                                };
                                $.post({
                                    url: MSH_SITE_URL + '/mshapi/favorites/postfavorites',
                                    dataType: 'json',
                                    contentType: 'application/json',
                                    data: JSON.stringify(postBody),
                                    xhrFields: {
                                        withCredentials: true
                                    },
                                }).done(function (data) {
                                    if (data.status === "success") {
                                        btn = getFavoriteButtonsByNodeGuid(nodeGUID);
                                        updateFavoriteButtonState(btn, false, nodeGUID, 0, true);
                                    }
                                }).fail(function () {
                                }).always(function () {
                                });
                            }
                        });
                    }
                    else {
                        if (type == 'event') {
                            //Post body
                            let postBody = {
                                FavoriteType: type,
                                NodeGuid: nodeGUID,
                                Action: 'add'
                            };
                            //Call favorite events API
                            $.post({
                                url: MSH_SITE_URL + '/mshapi/favorites/postfavoriteevents',
                                dataType: 'json',
                                contentType: 'application/json',
                                data: JSON.stringify(postBody),
                                xhrFields: {
                                    withCredentials: true
                                },
                            }).done(function (data) {
                                if (data.IsSuccess) {
                                    btn = getFavoriteButtonsByNodeGuid(nodeGUID);
                                    updateFavoriteButtonState(btn, true, nodeGUID, 0, true);
                                }
                            }).fail(function () {
                            }).always(function () {
                            });
                        } else {
                            //Post body
                            let postBody = {
                                type: type,
                                addRemove: 'add',
                                nodeGuid: nodeGUID
                            };
                            // Make MVC request to favorite the community
                            $.post({
                                url: MSH_SITE_URL + '/mshapi/favorites/postfavorites',
                                dataType: 'json',
                                contentType: 'application/json',
                                data: JSON.stringify(postBody),
                                xhrFields: {
                                    withCredentials: true
                                },
                            }).done(function (data) {
                                if (data.status === "success") {
                                    // If one favorite is clicked, we should update the status of all 3 favorite buttons on the page.
                                    btn = getFavoriteButtonsByNodeGuid(nodeGUID);
                                    updateFavoriteButtonState(btn, true, nodeGUID, (type === "community") ? data.numfavcomms : 0, true);
                                }
                            }).fail(function () {
                            }).always(function () {
                            });
                        }
                    }
                }
                else {
                    // This is running in the localhost PL
                    if (isLiked === true) {
                        // Before removing favorite, confirm that they wish to in fact remove the favorite
                        // Open the unfavorite modal
                        $("#" + UNFAVORITE_MODAL_ID).foundation('open');

                        // Attach click handler to confirmation and cancel buttons on the unfavorite modal
                        $("#unfavorite-modal .confirmation-button").one("click", function () {
                            btn = getFavoriteButtonsByNodeGuid(nodeGUID);
                            updateFavoriteButtonState(btn, false, nodeGUID, 0, true);
                        });
                    }
                    else {
                        btn = getFavoriteButtonsByNodeGuid(nodeGUID);
                        updateFavoriteButtonState(btn, true, nodeGUID, 0, true);
                    }
                }
            });
            // Initialize Add This Message
            updateAddThisMessageSection($(this).data("node-guid"), isUserAuthorized);

            // Update Favorite Button Text
            updateFavoriteButtonText($(button));
        });
    }).fail(function () {
    }).always(function () {
    });
}
window.initFavoriteButtons = initFavoriteButtons;

function highlightLikeButtons(buttons, buttontype) {
    if (!buttons) {
        buttons = getAllFavoriteButtons();
    }

    if (buttontype == null) {
        buttontype = 'all';
    }

    var processResponse = function highlightLikeButtonsProcessResponse(data) {

        var favoritedItems = data;
        if (favoritedItems) {
            favoritedItems.forEach(function (fav, index) {
                let favButtonItems = getFavoriteButtonsByNodeGuid(fav.NodeGUID);
                favButtonItems.each(function (idx, btn) {
                    updateFavoriteButtonStateNoConfirmation(btn, true, fav.NodeGUID);
                });
            });
        }

        initFavoriteButtons(buttons);
    };

    if ('event' == buttontype) {
        //Call favorite events API
        $.get({
            url: MSH_SITE_URL + '/mshapi/favorites/getfavoriteevents/?favType=' + buttontype,
            dataType: 'json',
            xhrFields: {
                withCredentials: true
            },
        }).done(function (data) {
            processResponse(data.Results);
        });
    } else {
        if ('all' == buttontype) {
            //Call favorite events API
            $.get({
                url: MSH_SITE_URL + '/mshapi/favorites/getfavoriteevents/?favType=event',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
            }).done(function (data) {
                var eventData = data.Results;
                //Call legacy favorites API
                $.get({
                    url: MSH_SITE_URL + '/mshapi/favorites/getfavorites/?type=' + buttontype,
                    dataType: 'json',
                    xhrFields: {
                        withCredentials: true
                    },
                }).done(function (data) {
                    var allFavData = JSON.parse(data);
                    processResponse(allFavData.concat(eventData));
                });
            });
        } else {
            //Call legacy favorites API
            $.get({
                url: MSH_SITE_URL + '/mshapi/favorites/getfavorites/?type=' + buttontype,
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
            }).done(function (data) {
                processResponse(JSON.parse(data));
            });
        }
    }

}
window.highlightLikeButtons = highlightLikeButtons;

/**
 * Map a favorite type to it's marketing label
 * @param {any} favoriteType
 */
function favoriteTypeLabel(favoriteType) {
    const FAV_TYPE_LABEL_MAP =
    {
        'lot': 'quick move-in',
        'plan': 'home plan',
        'community': 'community'
    };

    //Default label is "page"
    var typeLabel = 'page';

    if (favoriteType && (favoriteType in FAV_TYPE_LABEL_MAP)) {
        typeLabel = FAV_TYPE_LABEL_MAP[favoriteType];
    }

    return typeLabel;
}

/**
 *
 * @param {bool} liked true to style as liked, otherwise style as unliked
 */
function updateFavoriteButtonState(button, liked, nodeGUID, numfavcomms, isUserAuthorized) {

    var favType = "search";
    favType = $(button).attr("data-type")

    var showScheduleTour = true;
    // make the output more exlpainatory
    if (favType === "lot" || favType === "plan") {
        favType = favoriteTypeLabel(favType);
        showScheduleTour = false;
    }

    if (liked === true) {
        // Like this icon
        $(button).addClass("liked");

        $(button).each(function (index) {
            updateFavoriteButtonText(this)
        })

        var message = "You can find this " + favType + " in your My Shea Home account, under <a href=\"" + MSH_SITE_URL + "/favorites/\">Favorites</a>.";
        $("#placeholder").replaceWith("<p id=\"placeholder\" class=\"p-large main-fav-paragraph\">" + message + "</p>");

        // If the number of favorited communities is more than 4 then add the schedule a visti section
        // Make sure don't add schedule a visit more than once 
        if (numfavcomms >= 5 && $('.schedule-visit-section').length == 0 && showScheduleTour) {
            $(".main-fav-paragraph").after("<div class=\"schedule-visit-section\"><hr/><div class=\"cta-wrapper\"><h4>Want to Schedule a Tour?</h4>" +
                "<p class=\"p-large cta-prompt\">Schedule a tour with a Shea Homes Representative and start your journey to owning your new Shea home.</p>" +
                "<a href=\"/new-homes-sales/schedule-visit/\" class=\"button centered-button cta\">Schedule a Tour</a>" +
                "</div></div>")
        } else if (numfavcomms < 5 || !showScheduleTour) {
            // If the number of liked communities come below 5 or we like a qmi or plan, we should not show the schedule
            // a visti section
            // Remove the schedule a visit section
            $('.schedule-visit-section').remove();
        }

        $("#" + FAVORITE_MODAL_ID).foundation('open');

        // Point to the unfavorite modal
        $(button).attr("aria-controls", UNFAVORITE_MODAL_ID);

        // Set the screen reader text
        var text = $(button).find(".show-for-sr");
        if (text) {
            $(text).text("Remove from Favorites");
        }
    }
    else if (liked === false) {
        // Unlike this icon
        $(button).removeClass("liked");

        $(button).each(function (index) {
            updateFavoriteButtonText(this)
        });

        // Point to the favorite modal now
        $(button).attr("aria-controls", FAVORITE_MODAL_ID);

        // Close the unfavorite modal
        $("#" + UNFAVORITE_MODAL_ID).foundation('close');

        // Set the screen reader text
        var text = $(button).find(".show-for-sr");
        if (text) {
            $(text).text("Add to Favorites");
        }

        // Check if this is a favorites-listing instance..if so, remove the related elements from the DOM
        var favoritesListing = $($(button).parents($(".favorites-listing")));
        if (favoritesListing != null && favoritesListing.length > 0 && nodeGUID != null) {
            // Find the elements with data-associated-node-guid property with the specified GUID
            var associatedElements = $("[data-associated-node-guid='" + nodeGUID + "']").not("[data-is-recent-viewed-page='true']");
            if (associatedElements != null) {
                associatedElements.hide('slow', function () { associatedElements.remove(); });
            }
        }
    }
    updateAddThisMessageSection(nodeGUID, isUserAuthorized);
}

window.updateFavoriteButtonState = updateFavoriteButtonState;

function updateAddThisMessageSection(nodeGUID, isUserAuthorized) {
    var addThisButton = $("button[data-node-guid='" + nodeGUID + "']")
    var addThisLabelContainer = addThisButton.parent().parent().find(".h5");
    var addThisMessageContainer = addThisButton.parent().find(".general-share_save");
    if (addThisMessageContainer.length) {
        var signInUrl = $("#hfSignInUrl").val();
        var isLiked = addThisButton.hasClass("liked");
        var type = addThisButton.data("type");
        var typeLabel = favoriteTypeLabel(type);

        var message = "";
        var label = "";
        if (!isUserAuthorized) {
            message = "Save this " + typeLabel + " to your My Shea Home account.<br /><a href=\"" + signInUrl + "\">Click here to Sign In</a></span><span class=\"spacer\"> | </span><span>Don't have an account yet? <a href=\"" + signInUrl + "\">Create one now</a>";
            label = "Save to favorites";
        }
        else if (isLiked) {
            message = "You can find this " + typeLabel + " in your My Shea Home account, under <a href=\"" + MSH_SITE_URL + "/favorites/\">Favorites</a>.";
            label = "Saved to favorites";
        }
        else {
            message = "Save this " + typeLabel + " to your My Shea Home account.";
            label = "Save to favorites";
        }
        addThisLabelContainer.html(label);
        addThisMessageContainer.html("<span>" + message + "</span>");
    }
}
/**
 *
 * @param {bool} liked true to style as liked, otherwise style as unliked
 * We don't need a confirmation msg when we refresh all the buttons.
 */
function updateFavoriteButtonStateNoConfirmation(button, liked, nodeGUID) {
    if (liked === true) {
        // Like this icon
        $(button).addClass("liked");
        var favType = $(button).attr("data-type")
        $(button).each(function (index) {
            if (this.innerHTML.trim() === "Save to Favorites") {
                if (favType === "event") {
                    this.innerHTML = "Remove from Favorites";
                }
                else {
                    this.innerHTML = "Saved to Favorites";
                }
            }
            else if (this.innerHTML.trim() === "Save Floor Plan") {
                this.innerHTML = "Saved Floor Plan";
            }
        });

        // Point to the unfavorite modal
        $(button).attr("aria-controls", UNFAVORITE_MODAL_ID);

        // Set the screen reader text
        var text = $(button).find(".show-for-sr");
        if (text) {
            $(text).text("Remove from Favorites");
        }
    }
    else if (liked === false) {
        // Unlike this icon
        $(button).removeClass("liked");

        $(button).each(function (index) {
            if (this.innerHTML.trim() === "Saved to Favorites" || this.innerHTML.trim() === "Remove from Favorites") {
                this.innerHTML = "Save to Favorites";
            }
            else if (this.innerHTML.trim() === "Saved Floor Plan") {
                this.innerHTML = "Save Floor Plan";
            }
        });

        // Point to the favorite modal now
        $(button).attr("aria-controls", FAVORITE_MODAL_ID);

        // Set the screen reader text
        var text = $(button).find(".show-for-sr");
        if (text) {
            $(text).text("Add to Favorites");
        }
    }
    updateAddThisMessageSection(nodeGUID, true);
}

function getFavoriteButtonsByNodeGuid(nodeGuid) {
    return $(".card-like-button[data-node-guid='" + nodeGuid + "'], .like-button[data-node-guid='" + nodeGuid + "'], .floor-plan-save-button[data-node-guid='" + nodeGuid + "']");
}

function getAllFavoriteButtons() {
    return $('.card-like-button, .like-button, .floor-plan-save-button');
}

function updateFavoriteButtonText(button) {
    if ($(button).length) {
        // Check if the span exist in the button then we need to update the innerHTML
        var buttonSpan = $(button)[0].firstElementChild;
        if ($(buttonSpan).length) {
            var isLiked = $(button).hasClass("liked");
            var isFloorPlan = $(button).hasClass("floor-plan-save-button");
            if (isLiked && !isFloorPlan) {
                $(buttonSpan).text("Saved to Favorites");
            }
            else if (!isLiked && !isFloorPlan) {
                $(buttonSpan).text("Save to Favorites");
            }
            else if (isLiked && isFloorPlan) {
                $(buttonSpan).text("Saved Floor Plan");
            }
            else if (!isLiked && isFloorPlan) {
                $(buttonSpan).text("Save Floor Plan");
            }
        }
    }
}